import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router, RoutesRecognized } from "@angular/router";
import { LoadingController } from "@ionic/angular";
import { Subject, Subscription } from "rxjs";
import { filter, last, pairwise, take, takeUntil } from "rxjs/operators";
import { BonusService } from "src/app/services/bonus/bonus.service";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";

@Component({
  selector: "app-promotions-list",
  templateUrl: "./promotions-list.component.html",
  styleUrls: ["./promotions-list.component.scss"],
})
export class PromotionsListComponent implements OnInit, OnDestroy {
  public promotionsAll = [];
  public promotionsList = [];
  public showPromoDetail = false;
  public promoDetailInfo = null;
  public listFilterStatus = "NotGranted"; // This variable sets the sub tab.
  public isLoggedIn = false;
  public loading: any;

  private callAllGetBonusOffersSubscription: Subscription;
  private callGetBonusOffersSubscription: Subscription;
  private navSubscription: Subscription;
  private getCustomerSub: Subscription;
  private calledngOnInit = false; // To avoid duplicate calls at the same time.
  protected ngUnsubscribe: Subject<void> = new Subject<void>();

  private excludedCampaignCodes;
  private offerFilter;


    
  constructor(
    private bonusSrvc: BonusService,
    private configService: ConfigService,
    public userSession: UserSessionService,
    private router: Router,
    private events:EventsService,
    public loadingController: LoadingController
  ) {
    this.navSubscription = this.router.events
      //.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((e: any) => {
        // If it is NavigationEnd event reload the promotions component.
        // This is required because when player moves from Keyword Tabs the component is not reloaded.
        // Can be improved to have white list of urls instead of black list.
        if (
          e[1].url == "/promotions" &&
          !this.calledngOnInit &&
          (this.bonusSrvc.getPromoDetailInfo() ||
            this.bonusSrvc.getPromoReload() ||
            e[0].url != e[1].url) &&
          !e[0].url.includes("signupstep") &&
          !e[0].url.includes("login") &&
          !e[0].url.includes("myfreespin") &&
          !e[0].url.includes("bonusdetails") &&
          (!e[0].url.includes("deposit") || e[0].url.includes("depositsuccessfailure") )
        ) {
          this.bonusSrvc.setPromoReload(false);
          this.ngOnInit();
          this.calledngOnInit = true;
          let timeHandle = setTimeout(() => {
            this.calledngOnInit = false;
            clearTimeout(timeHandle);
          }, 50);
        } else {
          this.getCustomerSub?.unsubscribe();
        }
      });
  }

  ngOnInit() {
    /*if (this.router.getCurrentNavigation().extras?.state?.campaignId) {
      this.showPromoDetail = true;
    }*/
    this.excludedCampaignCodes = JSON.parse(this.configService.getConfig().FEATURE_PROMOTIONS_LIST_EXCLUDED_CODES) || [
      "ZZ_NO_DEPOSIT",
      "NOWELCOMEOFFER",
      "ZZ_NO_WELCOME"
    ];
    this.offerFilter = (item) =>
    !this.excludedCampaignCodes.some((code) => item.campaign_code?.includes(code));

    this.events.subscribe("event:login", () => {
      this.userSession.isAuthenticated().then((res) => {
        this.isLoggedIn = res;
      });
    });
    this.showLoading().then( () => {
      this.listFilterStatus = this.listFilterStatus ? this.listFilterStatus : "NotGranted";
      this.showPromoDetail = false;
      this.promoDetailInfo = null;
      this.userSession.isAuthenticated().then((res) => {
        if (res) {
          this.getCustomerSub = this.userSession.getCustomer().subscribe(() => {
            this.isLoggedIn = true;
            this.getLoggedInOffersList();
            if (this.bonusSrvc.getPromoDetailInfo()) {
              this.listFilterStatus = this.bonusSrvc.getPromoDetailInfo()?.listType;
              this.getLoggedInOffersList();
            }
          });
        } else {
          this.isLoggedIn = false;
          this.getNotGrantedOffers();
        }
      });
    });
  }

  getLoggedInOffersList() {
    console.log('getLoggedInOffersList');
    
    this.ngUnsubscribe.next();
    switch (this.listFilterStatus) {
      case "IN_PROGRESS":
        this.getOffersInprogressAndPast("IN_PROGRESS");
        break;
      case "DONE":
        this.getOffersInprogressAndPast("DONE");
        break;
      default:
        this.getNotGrantedOffers();
        break;
    }
  }

  getOffersInprogressAndPast(filterStatus) {
    this.callAllGetBonusOffersSubscription = this.bonusSrvc
      .callAllGetBonusOffers()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          let resDataPromosAuthenticated = response?.payload
            ? response.payload
            : [];
          this.promotionsAll = this.promotionsAll.length > 0 ? this.promotionsAll.concat(resDataPromosAuthenticated) : this.promotionsAll = resDataPromosAuthenticated;
          this.promotionsList = resDataPromosAuthenticated
            .filter(this.offerFilter)
            .filter((toFilter) => toFilter.status == filterStatus)
            .map((resData) => {
              resData.banner_image_small =
                this.configService.getCampaignBanerImgUrl(resData).sm;
              resData.banner_image_medium =
                this.configService.getCampaignBanerImgUrl(resData).md;
              resData.banner_image_large =
                this.configService.getCampaignBanerImgUrl(resData).lg;
              return resData;
            });

          if (this.bonusSrvc.getPromoDetailInfo()) {
            this.openPromoDetailPageBasedOnId();
          }
        },
        (error) => {},
        () => {
          this.loading?.dismiss();
        }
      );
  }

  getNotGrantedOffers() {
    this.callGetBonusOffersSubscription = this.bonusSrvc
      .callGetBonusOffers()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          let resDataPromos = response?.payload ? response.payload : [];
          this.promotionsAll = this.promotionsAll.length > 0 ? this.promotionsAll.concat(resDataPromos) : this.promotionsAll = resDataPromos;
          this.promotionsList = resDataPromos
            .filter(this.offerFilter)
            .map((resData) => {
              resData.banner_image_small =
                this.configService.getCampaignBanerImgUrl(resData).sm;
              resData.banner_image_medium =
                this.configService.getCampaignBanerImgUrl(resData).md;
              resData.banner_image_large =
                this.configService.getCampaignBanerImgUrl(resData).lg;
              return resData;
            });
            if (this.bonusSrvc.getPromoDetailInfo()) {
              this.openPromoDetailPageBasedOnId();
            }
        },
        (error) => {},
        () => {
          this.loading?.dismiss();
        }
      );
  }

  switchOffersList(value) {
    this.promotionsList = null;
    this.listFilterStatus = value?.detail?.value;
    this.getLoggedInOffersList();
  }

  openPromoDetailPage(data) {
    this.promoDetailInfo = data;
    this.showPromoDetail = true;
  }

  openPromoDetailPageBasedOnId() {
    this.promoDetailInfo = this.promotionsAll.filter(
      (data) => data.id == this.bonusSrvc.getPromoDetailInfo().id
    )[0];
    this.showPromoDetail = true;
  }

  closeDetailWindow() {
    this.showPromoDetail = false;
    // This is to handle if the promo detail page was opened from deep link.
    if (!this.promoDetailInfo.status) {
      this.switchOffersList({ detail: { value: "NotGranted" } });
    } else {
      this.switchOffersList({ detail: { value: this.promoDetailInfo.status } });
    }
    this.promoDetailInfo = null;
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: "Loading...",
      duration: 10000,
    });

    this.loading.present();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.navSubscription?.unsubscribe();
    if(this.getCustomerSub?.unsubscribe) {
       this.getCustomerSub?.unsubscribe();
    }
  }
}
